import { Controller } from "@hotwired/stimulus";

// Bascule entre les versions d'un media template (un onglet par version).
// L'onglet actif est marqué par data-active, stylé via les variants Tailwind data-[active].
// Les panneaux inactifs sont rendus transparents, jamais masqués : ils sont empilés dans la
// même cellule de grille, gardent leurs dimensions et donc leur preview déjà mise à l'échelle.
export default class extends Controller {
  static targets = ["tab", "panel"];

  select(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);

    this.tabTargets.forEach((tab, i) => tab.toggleAttribute("data-active", i === index));
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("opacity-0", i !== index);
      panel.classList.toggle("pointer-events-none", i !== index);
    });
  }
}
